import './style.css';
import {useEffect, useState} from 'react';
import ProductList from '../../components/ProductList';
import { TIPS } from '../../data/Advices.js';

function AdvicesContainer(){
    const [advices, setAdvices] = useState([]);
    useEffect(() => {
        setAdvices(TIPS);
    }, []);

    return <main className="home-container">
        <ProductList items={advices} title="Consejos" path="consejos"/>
    </main>
}

export default AdvicesContainer;